import { h, Fragment } from 'preact'
import { IPurchaseOrderHtml } from './types'
import * as moment from 'moment'
import {  isObject } from 'lodash'

export const TmpOrderHeaderBill = ({ order, qr_ordercode,warehouse,logo}: { order: IPurchaseOrderHtml.Order; qr_ordercode: string,warehouse:any ,logo:string}) => {

  let assignee_display = '-'
   if (order.assignee && order.assignee.length) {
        assignee_display = order.assignee.map((x) => `${x.user.name} ${x.user.lastname}`).join(', ')
      }

  return (
    <Fragment>
      <div class="page-slip company">
        <div class="company_logo">
          <img src={logo}></img>
        </div>
      </div>
      <div class="page-slip company">
        <div class="company_detail text-small pt-2">
          <div>{warehouse.org_name || ''}</div>
          <div>{warehouse.org_address || ''}</div>
          <div>เลขนิติบุคคล : {warehouse.tax_no || ''} </div>
          <div>Tel. {warehouse.org_phone || ''}</div>
        </div>
      </div>
      
      <div class="page-slip order-header-wrapper bordernone text-small">
        <div class="order-header-qrcode">
          <img class="order-header-qrcode-image" src={qr_ordercode} />
        </div>
        <div>
          <div class="order-header-detail">
            <div>Order No. {order.ordercode}</div>
            <div>วันที่สั่งซื้อ : {moment(order.created_at).format('YYYY-MM-DD, HH:mm:ss')}</div>
            <div>สถานะ : {order.status_name}</div>
            <div>ช่องทางการขาย : {order.channel}</div>
          </div>
        </div>

      </div>
      <div class="page-slip border-bottom order-header-detail text-small">
        <div>ผู้ดูแล : {assignee_display}</div>
        {order.shipping_group_id > 0 && isObject(order.shipping_group) && (
              <div>Batch : {order.shipping_group.shipping_group_name}</div> )}
        <div>Tracking Code : <span class="text-title ">{order.trackcode || '-'}</span></div>
        <div>ขนาดกล่อง : {order.box_name || '-'} {order.box_value || '-'}</div>
      </div>
    </Fragment>
  )
}


